









import Vue from 'vue'
import {mapState, mapGetters, mapActions} from 'vuex'
import {MapWithDefault} from '../utils'
import { Plotly } from 'vue-plotly'

export default Vue.extend({
  components: { Plotly },
  props: {
    title: {type: String},
    field: {type: String},
    orientation: {type: String, default: 'h'}
  },
  data() {
    return {
      plotLayout: {
        title: this.title,
        showlegend: false,
        dragmode: 'select',
        barmode: 'stack',
        yaxis: this.orientation=='h' ? {autorange: 'reversed', dtick: 1} : {},
        xaxis: this.orientation=='v' ? {autorange: 'reversed', dtick: 1} : {},
        margin: this.orientation=='h' ? {l: 100} : {},
        font: {size: 12, family: 'Open Sans Condensed'},
        hoverlabel: {font: {family: 'Open Sans Condensed'}},
      },
    }
  },
  computed: {
    ...mapState(['entries', 'selectedKeys', 'keyField']),
    ...mapGetters(['entriesCount', 'selectedKeysCount', 'fieldLevels', 'fieldTypes']),
    plotData() {
      console.log(`computing plotData for ${this.field}...`, Date.now())
      const levels: Array<string> | undefined = (this.fieldLevels as Map<string, Array<string>>).get(this.field)
      const type = this.fieldTypes.get(this.field)
      if (Array.isArray(levels)) {
        const countsTotal = new MapWithDefault<string, number>(()=>0)
        const countsSelected = new MapWithDefault<string, number>(()=>0)
        for (const level of levels) {
          countsTotal.set(level, 0)
          countsSelected.set(level, 0)
        }
        for (const entry of this.entries) {
          const values = (type === 'array' ? entry[this.field] : [entry[this.field]])
          const isSelected = this.selectedKeys.has(entry[this.keyField])
          for (const value of values) {
            countsTotal.set(value, countsTotal.get(value) + 1)
            if (isSelected) {
              countsSelected.set(value, countsSelected.get(value) + 1)
            }
          }
        }
        const traceTotal = {
          name: 'all',
          type: 'bar',
          orientation: this.orientation,
          y: this.orientation=='h' ? [...countsTotal.keys()] : [...countsTotal.values()],
          x: this.orientation=='h' ? [...countsTotal.values()] : [...countsTotal.keys()],
          base: 0,
          marker: {color: 'rgb(248, 235, 255)'}
        }
        const traceSelected = {
          name: 'selected',
          type: 'bar',
          orientation: this.orientation,
          y: this.orientation=='h' ? [...countsSelected.keys()] : [...countsSelected.values()],
          x: this.orientation=='h' ? [...countsSelected.values()] : [...countsSelected.keys()],
          base: 0,
          marker: {color: 'rgb(133, 111, 187)'}
        }
        console.log(`computing plotData for ${this.field} done!`, Date.now())
        return [traceTotal, traceSelected]
      } else {
        return []
      }
    },
  },
  methods: {
    ...mapActions(['setFilter']),
    select(levels: Set<string>) {
      let filter = null
      if (levels?.size == 1) {
        filter = [this.field, '=', ...levels]
      } else if (levels?.size > 1) {
        filter = [this.field, 'anyof', [...levels]]
      }
      (this as any).setFilter({filter})
    },
    selected(e: any) {
      if (e) {
        (this.$refs.plot as any).restyle({selectedpoints: []}) // resets the selection rectangle but keeps the selectedpoints
        const values = new Set<string>( e.points.map( (point: any) => this.orientation=='h' ? point.y : point.x ) );
        (this as any).select(values)
      }
    },
    deselect() {
      console.log('deselect')
      //this.select(null)
    },
    click(e: any) {
      if (e.event.detail == 1) {
        const value = this.orientation=='h' ? e.points[0].y : e.points[0].x;
        (this as any).select(new Set([value]))
      }
    }
  }
})
